module.exports = __webpack_public_path__ + "static/media/29DUNON8.1dc0cd2b.jpg";